export const permissionMapping = {
    "viewclient": ["Client"],
    "viewplan": ["Package"],
    "viewnews": ["Package"],
    "viewcategory": ["Category"],
    "viewsignal": ["OpenSignal", "CloseSignal"],
    "viewnews": ["News"],
    "viewbanner": ["Banner"],
    "viewcoupon": ["Coupon"],
    "viewblogs": ["Blogs"],
    "viewfaq": ["FAQ"],
    "viewfreeclient": ["FreeTrialClient"],
    "perform": ["Performance"],
    "vewbasket": ["BasketDetail", "BasketStockPublished"],
    "allbaskethistory": ["SubscriptionHistory"],
    "viewfreeclient": ["FreeTrialClient"],
    "paymenthistory": ["PaymentHistory"],
    "planexpiry": ["ClientPlanExpiry"],
    "ticket": ["HelpDisk"],
    "broadcast": ["BroadcastSMS"]
};




